
import { ElementContainer } from "../../../../library-js/dom-tools/ElementContainer";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { MultiString } from "../../../../library-js/i18n/MultiString";
import { AppCommand } from "../../../../library-js/web-app/commands/AppCommand";
import { ContextMenu } from "../../../../library-templates/context--menu/ContextMenu";
import { RokojoriContextMenu } from "../../context-menu/RokojoriContextMenu";
import { RokojoriWebApp } from "./RokojoriWebApp";

export class RokojoriWebAppToolbar extends ElementContainer<Element>
{
  static readonly type = new ElementType( "web-app-tool-bar" )
  static readonly entry = new ElementType( "tool-entry" );
  static readonly entries = new ElementType( "tool-entries" );

  protected _app:RokojoriWebApp<any,any>
  get app(){ return this._app; }

  constructor( app:RokojoriWebApp<any,any> )
  {
    super();

    let element =  app.$.templatesManager.createTemplate( RokojoriWebAppToolbar.type.selector );
    this._setElement( element as any );
    this._app = app;
    
  }

  add( name:string|MultiString, creator:()=> ContextMenu )
  {
    let entries = RokojoriWebAppToolbar.entries.query( this.element );

    let label = MultiString.resolve( name );
    let entry = RokojoriWebAppToolbar.entry.create( label );

    entries.appendChild( entry );


    RokojoriContextMenu.addContextMenuElement( entry, label, creator  );

    return entry;    
  }

  createEntry( label:MultiString, commands:AppCommand[] )
  {
    this.add( label, 
      ( )=>
      { 
        let cm = new ContextMenu( MultiString.resolve( label ) );

        commands.forEach(
          ( e )=>
          {
            let item = cm.addEntry( MultiString.resolve( e.name ) );

            OnClick.add( item.htmlElement, ()=>{ e.run(); } );
                        
          }
        );

        return cm;
      }
    );
  }


}